<template>
    <div class="w-full flex flex-column gap-6">
        <span class="flex text-900 font-medium text-3xl xl:text-6xl lg:text-5xl md:text-4xl justify-content-center">
            {{ content[lang_].title }}
        </span>
        <div class="flex w-full flex-column justify-content-center align-items-center m-auto" style="max-width:640px;">
            <img src="/images/svg/about/merchant.svg" class="max-w-10rem m-auto mb-4">
            <span class="inline-block m-auto justify-content-center align-items-center text-center text-600 text-lg line-height-2">
                {{ content[lang_].text }}
            </span>
        </div>

        <div class="flex flex-column gap-3 w-full max-w-30rem m-auto">
            <span class="flex text-600 text-md justify-content-center">{{ content[lang_].titleTodo }}:</span>
            <MobMenu :items=[]>
                <template v-slot:body>
                    <!--TG-->
                    <div class="w-full flex flex-row px-3 py-2 border-100 cursor-pointer border-bottom-1" style="min-height:50px" @click="toProfile(isTelegram)">
                        <div class="flex mr-3 align-items-center">
                            <Avatar class="text-600" size="small" icon="pi pi-telegram" shape="circle"/>
                        </div>
                        <div class="flex flex-1 justify-content-left align-items-center">
                            <span class="text-600">{{ content[lang_].doLinkTelegram }}</span>
                        </div>
                        <div class="flex justify-content-right align-items-center">
                            <i v-if="isTelegram" class="text-500 ml-2 pi pi-check" />
                            <i v-else class="text-blue-500 ml-2 pi pi-angle-right" />
                        </div>
                    </div>

                    <div class="w-full flex flex-row px-3 py-2 border-100 cursor-pointer border-bottom-1" style="min-height:50px" @click="toVerify(isVerified)">
                        <div class="flex mr-3 align-items-center">
                            <Avatar class="text-600" size="small" icon="pi pi-verified" shape="circle"/>
                        </div>
                        <div class="flex flex-1 justify-content-left align-items-center">
                            <span class="text-600">{{ content[lang_].doKYC }}</span>
                        </div>
                        <div class="flex justify-content-right align-items-center">
                            <i v-if="isVerified" class="text-500 ml-2 pi pi-check" />
                            <i v-else class="text-blue-500 ml-2 pi pi-angle-right" />
                        </div>
                    </div>

                </template>
            </MobMenu>
            <Button :label="content[lang_].btn" @click="toShowRules()" class="border-round-lg" :disabled="!isTelegram || !isVerified"/>
            <!-- <Button :label="content[lang_].btn" @click="showRules=true" class="border-round-lg" /> -->
        </div>

        <div class="flex w-full flex-column faqStepsCom m-auto" style="max-width:640px;">
            <span class="flex text-700 align-items-center text-center font-medium mb-4 xl:mb-6 justify-content-center
                text-xl xl:text-4xl lg:text-5xl md:text-4xl">
                {{ content[lang_].faq }}
            </span>
            <FaqShortList v-if="tabs" :tabs="tabs" :count="4" />
        </div>
    </div>
			
    <Dialog v-model:visible="showRules" :header="content[lang_].agree_title" blockScroll modal
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { width: '100%', height: '100%' } : { width: '900px' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: '500px' }"
        class="border-none mx-2">
        <div class="w-full">
           <MerchantRules />
        </div>
        <template #footer>
            <span class="w-full flex flex-column">
                <div class="w-full flex flex-row gap-2 justify-content-start align-items-center py-2">
                    <Checkbox v-model="checked" :binary="true" class="flex" />
                    <span class="flex" @click="checked=!checked">{{ content[lang_].agree }}</span>
                </div>
                <Button :label="content[lang_].btnAccept" icon="pi pi-check" @click="be()" 
                    :loading="loading" :disabled="loading || (!checked || !isTelegram || !isVerified)"
                    class="flex border-round-xl w-full" />
                <!-- <Button :label="content[lang_].btnAccept" icon="pi pi-check" @click="be()" 
                    :loading="loading" 
                    class="flex border-round-xl w-full" /> -->
            </span>
        </template>
    </Dialog>
</template>

<script>
import Connect          from '@/assets/js/Connect'
import Helper           from '@/assets/js/Helper'
import MobMenu          from '@/components/sides/menu/MobMenu.vue'
import MerchantRules    from '@/components/merchant/Rules.vue'
import FaqShortList     from '@/components/widgets/FaqList.vue'
import Event            from '@/assets/js/Event.js'

export default {
    data() {
        return {
            user: null,
            loading: false,

            isTelegram: false,
            isVerified: true,

            showRules: false,
            checked: false,

            activeIndex: 0,
            tabs: null,
            content: {
                ru: {
                    title: 'Торговля валютой',
                    titleTodo: 'Требуется выполнить действия',
                    doLinkTelegram: 'Привязать Telegram',
                    doKYC: 'Пройти верификацию',
                    agree_title: 'Правила работы мерчанта',
                    btn: 'Стать мерчантом',
                    btnAccept: 'Принять условия',
                    text: 'Станьте мерчантом на платформе PayWave и начните принимать переводы от пользователей и зарабатывать на комиссиях.',
                    text_steps: 'Для того чтобы стать мерчантом, выполните следующие шаги:',
                    telegram_on: 'Телеграм подключен',
                    telegram_off: 'Подключите телеграм в профиле',
                    btn_profile: 'Профиль',
                    wallet_on: 'Кошелек создан',
                    wallet_off: 'Создайте кошелек',
                    payment_on: 'Методы оплаты добавлены',
                    payment_off: 'Добавьте методы оплаты',
                    btn_add: 'Добавить',
                    agree: 'Согласен с правилами',
                    faq: 'Вопрос-ответ',
                    success: 'Успех',
                    successText: 'Вы стали мерчантом',
                    error: 'Ошибка',
                    errorText: 'Ошибка регистрации мерчанта',
                },
                en: {
                    title: 'Currency trading',
                    titleTodo: 'You need to do the following',
                    doLinkTelegram: 'Link Telegram',
                    doKYC: 'Pass verification',
                    agree_title: 'Merchant rules',
                    btn: 'Become a merchant',
                    btnAccept: 'Accept terms',
                    text: 'Become a merchant on the PayWave platform and start accepting transfers from users and earning commissions.',
                    text_steps: 'To become a merchant, follow these steps:',
                    telegram_on: 'Telegram connected',
                    telegram_off: 'Connect telegram in profile',
                    btn_profile: 'Profile',
                    wallet_on: 'Wallet created',
                    wallet_off: 'Create a wallet',
                    payment_on: 'Payment methods added',
                    payment_off: 'Add payment methods',
                    btn_add: 'Add',
                    agree: 'Agree with the rules',
                    faq: 'FAQ',
                    success: 'Success',
                    successText: 'You have become a merchant',
                    error: 'Error',
                    errorText: 'Merchant registration error',
                },
            },
            tabs: [
                {
                    ru: {
                        title: 'Кто такой мерчант?',
                        content: 'Мерчант - это пользователь, который принимает платежи и переводы от клиентов. Мерчант может принимать платежи в любой валюте и в любом объеме'
                    },
                    en: {
                        title: 'Who is a merchant?',
                        content: 'A merchant is a user who accepts payments and transfers from customers. A merchant can accept payments in any currency and in any amount'
                    }
                },
                {
                    ru: {
                        title: 'Зачем проходить верификацию?',
                        content: 'Верификация нужна для того, чтобы подтвердить вашу личность и обеспечить безопасность ваших клиентов.'
                    },
                    en: {
                        title: 'Why do I need to be verified?',
                        content: 'Verification is needed to confirm your identity and ensure the security of your customers.'
                    }
                },
                {
                    ru: {
                        title: 'Есть ли обучение?',
                        content: 'Да, у нас есть обучение для мерчантов. Вы сможете пройти обучение и начать работу'
                    },
                    en: {
                        title: 'Is there any training?',
                        content: 'Yes, we have training for merchants. You will be able to undergo training and start working'
                    }
                },
                {
                    ru: {
                        title: 'Что нужно для работы?',
                        content: 'Для работы потребуются банковские карты любых стран (желательно карты РФ).'
                    },
                    en: {
                        title: 'What do you need to work?',
                        content: 'To work, you will need bank cards from any country (preferably Russian cards).'
                    }
                }
            ]
        }
    },
    components: {
        MerchantRules,
        MobMenu,
        FaqShortList
    },
    methods: {
        showMess(severity, summary, detail) {
            this.$toast.add({severity: severity, summary: summary, detail: detail, life: 3000});
        },
        toProfile(isTelegram){
            if(isTelegram) return
            this.$router.push({path: '/personal/profile/'})
        },
        toVerify(isVerified){
            if(isVerified) return
            this.$router.push({path: '/verify/process/'})
        },
        toShowRules(){
            this.showRules = !this.showRules
            try { this.event.send('merchantJoin') } catch {}
        },
        async be() {
            try { this.event.send('merchantConfirm') } catch {}
            this.loading = true
            try {
                const add = await this.connect.GetMerchantProgram().then(res=>res).catch(err=>err)
                if(add.result && add.data){
                    this.showMess('success', this.content[this.lang_].success, this.content[this.lang_].successText)
                    this.showRules = false
                    await this.$store.dispatch('setAddGroup', 'merchant').then(() => {})
                    this.event.send('merchantSuccess')
                } else {
                    if(add.errors && add.errors.length > 0){
                        this.showMess('error', this.content[this.lang_].error, add.errors[0])
                    } else this.showMess('error', this.content[this.lang_].error, this.content[this.lang_].errorText)
                }
            } catch {
                this.showMess('error', this.content[this.lang_].error, this.content[this.lang_].errorText)
            }
            this.loading = false
        }
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        screenSize() { return this.$store.getters.StateScreenSize },
        isTelegram: function () { return this.$store.getters.StateTelegramUsername },
        isVerified: function () { return this.$store.getters.StateVerified },
        isDarkTheme() { return this.$store.getters.StateDarkTheme },
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
        this.event = new Event(this)
    },
    mounted() {
        this.helper.SetTgAppHeadColor('gray', this.isDarkTheme)
    },
}
</script>